module.exports = __webpack_public_path__ + "static/media/rfid4.9f4af659.jpg";